import { isUserEntity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import {
  isBusinessDomainEntity,
  isComponentEntity,
  isDataContractEntity,
  isIPenDomainEntity,
  isNewsEntity,
  isOrganisationalDomainEntity,
  isSolutionModuleEntity,
  isTribeEntity,
} from '@ipen-portal/ipen-entity-model';
import {
  and,
  isDummyDomainEntity,
  isEnergyNetworkDomainEntity,
  not,
  or,
  showMonitoring,
} from '@ipen-portal/plugin-common';
import {
  EnhancedNavItemBlueprint,
  EntityToolbarElementBlueprint,
} from '@ipen-portal/plugin-common-react';
import { Grid } from '@mui/material';

import { CatalogEntityPage } from './_backstage/alpha/CatalogEntityPage';
import { entityContents } from './_backstage/alpha/entityContents';
import { entityCards } from './cards';
import { IpenEntityLayoutExtension } from './extensions/IpenEntityLayoutExtension';
import { IpenMasonryLayoutExtension } from './extensions/IpenMasonryLayoutExtension';

const EntityContentOverride = entityContents.override({
  params: {
    filter: not(
      or(
        isTribeEntity,
        isNewsEntity,
        isEnergyNetworkDomainEntity,
        isBusinessDomainEntity,
        isOrganisationalDomainEntity,
        isIPenDomainEntity,
        isUserEntity,
        isDummyDomainEntity,
        isDataContractEntity,
      ),
    ),
    title: 'About',
  },
});

export const catalogModuleIpen = createFrontendModule({
  extensions: [
    EnhancedNavItemBlueprint.make({
      params: {
        featureFlag: 'ipen-catalog-page',
        icon: <Icon fontSize={32} icon="material-symbols:dvr-outline" />,
        pageTheme: 'default',
        target: '/catalog',
        title: 'Backstage',
      },
    }),
    EnhancedNavItemBlueprint.makeWithOverrides({
      factory(originalFactory) {
        return originalFactory({
          featureFlag: 'dev-nav',
          icon: <Icon fontSize={32} icon="mdi:library-books" />,
          target: '/create',
          title: 'Scaffolders',
        });
      },
      name: 'scaffolder',
    }),
    CatalogEntityPage,
    IpenEntityLayoutExtension,
    EntityContentOverride,
    IpenMasonryLayoutExtension,
    ...entityCards,

    EntityContentBlueprint.make({
      name: 'DependenciesComponentsPage',
      params: {
        filter: and(
          showMonitoring,
          isComponentEntity,
          not(isSolutionModuleEntity),
        ),
        icon: <Icon icon="bx:network-chart" />,
        loader: async () => {
          const {
            EntityDependsOnComponentsCard,
            EntityDependsOnResourcesCard,
          } = await import('@backstage/plugin-catalog');
          return (
            <Grid alignItems="stretch" container spacing={3}>
              <Grid item md={6}>
                <EntityDependsOnComponentsCard />
              </Grid>
              <Grid item md={6}>
                <EntityDependsOnResourcesCard />
              </Grid>
            </Grid>
          );
        },
        path: '/dependencies',

        title: 'Dependencies',
      },
    }),
    EntityToolbarElementBlueprint.make({
      name: 'EntityContentEditButton',
      params: {
        component: async () =>
          import('@ipen-portal/plugin-common-react').then(m => ({ entity }) => (
            <m.EditButton entity={entity} variant="circle" />
          )),
        path: '/',
      },
    }),
  ],
  featureFlags: [{ name: 'ipen-catalog-page' }, { name: 'show-entity-errors' }],
  pluginId: 'catalog',
});
